module.exports = {
  "wrapper": {
    "zIndex": 999
  },
  "g-cover": {
    "position": "fixed",
    "top": 0,
    "right": 0,
    "left": 0,
    "bottom": 0,
    "zIndex": 1
  },
  "g-popover": {
    "position": "fixed",
    "paddingTop": "15",
    "paddingRight": "15",
    "paddingBottom": "15",
    "paddingLeft": "15",
    "zIndex": 10,
    "width": "384"
  },
  "u-popover-arrow": {
    "position": "absolute",
    "borderRadius": "4",
    "width": "30",
    "height": "30",
    "backgroundColor": "#000000"
  },
  "u-popover-inner": {
    "borderRadius": "10",
    "overflow": "hidden",
    "backgroundColor": "#000000",
    "paddingTop": "6",
    "paddingRight": "6",
    "paddingBottom": "6",
    "paddingLeft": "6"
  },
  "i-btn": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "marginLeft": "20",
    "marginRight": "20",
    "paddingTop": "10",
    "paddingRight": "10",
    "paddingBottom": "10",
    "paddingLeft": "10"
  },
  "i-btn-noborder": {
    "backgroundColor": "#000000"
  },
  "btn-icon": {
    "width": "32",
    "height": "32",
    "marginRight": "16"
  },
  "btn-text": {
    "flex": 1,
    "fontSize": "30",
    "lineHeight": "40"
  },
  "text-align-center": {
    "textAlign": "center"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-531cb942!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-popover/index.vue
// module id = 470
// module chunks = 0 1